export const constants = {
	api_url: 'https://projects.fantom.network/api',
	rpc_api: 'https://rpcapi.fantom.network',
	monitor_node_api: 'https://monitor.fantom.network/api',
	llma_api: 'https://api.llama.fi',
}